import { ItemList } from 'models/InputLayoutItem';

function getYearOptions(): ItemList[] {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const TOTAL_YEARS = 8;

    const result: ItemList[] = [];

    // Siempre: 8 años hacia atrás desde el año actual
    for (let i = 0; i < TOTAL_YEARS; i++) {
        const year = currentYear - i;
        result.push({
            label: year.toString(),
            value: year.toString(),
        });
    }

    // Si estamos en septiembre o más adelante, agregamos el próximo año
    if (currentMonth >= 9) {
        const nextYear = (currentYear + 1).toString();
        result.unshift({
            label: nextYear,
            value: nextYear,
        });
    }

    return result;
}

export default getYearOptions;
